var _rect, _g, _path, _path2, _g2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgCareInsurance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 106,
    viewBox: "0 0 112 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 106,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_40_2721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-39 -16C-39 -22.6274 -33.6274 -28 -27 -28H139C145.627 -28 151 -22.6274 151 -16V159.231C151 165.858 145.627 171.231 139 171.231H-27C-33.6274 171.231 -39 165.858 -39 159.231V-16Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.375 53.5C111.375 82.4949 87.8699 106 58.875 106C29.8801 106 6.375 82.4949 6.375 53.5C6.375 24.5051 29.8801 1 58.875 1C87.8699 1 111.375 24.5051 111.375 53.5Z",
    fill: "#D6E8F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_40_2721",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 1,
    width: 106,
    height: 105
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.375 53.5C111.375 82.4949 87.8699 106 58.875 106C29.8801 106 6.375 82.4949 6.375 53.5C6.375 24.5051 29.8801 1 58.875 1C87.8699 1 111.375 24.5051 111.375 53.5Z",
    fill: "#D6E8F6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_40_2721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8693 21.1465L62.373 62H70.873C82.626 53.3935 83.4449 21.1465 68.8693 21.1465Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8685 21.1474C66.925 19.9674 56.6679 16.9706 48.8789 21.1474C39.3007 26.2836 32.8616 43.3061 46.373 62C49.3923 62.0265 52.8728 62 52.8728 62L68.8685 21.1474Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7077 58.167H66.6473V55.5731H51.1V58.1643C51.1 60.7029 51.0894 63.4622 48.8789 65.1313V89.9994H58.8737C58.8737 89.9994 64.1072 89.9994 68.8684 89.9994V65.0925C66.7145 63.4192 66.7077 60.6838 66.7077 58.167Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8741 81.4123C55.5682 81.4123 51.3948 78.7109 49.373 77.2955L52.2109 110H67.7582V77.2955C65.2389 79.8835 62.18 81.4123 58.8741 81.4123Z",
    fill: "#3A8761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7575 70.0111C68.1627 70.1216 68.5276 70.1805 68.868 70.2092V65.0936C66.7142 63.4203 66.7073 60.6848 66.7073 58.168L66.7058 58.1036V55.5096L54.4312 55.5741L51.0996 56.6846C53.3207 59.1835 60.1228 67.9289 67.7575 70.0111Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4207 41.1358C74.4207 50.029 65.5761 61.1253 58.8735 61.1253C52.1708 61.1253 43.3262 50.029 43.3262 41.1358C43.3262 32.2426 50.287 28.92 58.8735 28.92C67.4599 28.92 74.4207 32.2426 74.4207 41.1358Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0953 23.3672C60.4713 23.3672 58.4455 24.0683 56.7897 24.6826L56.6532 24.4777C56.6532 24.4777 56.4247 24.6573 56.0291 24.9685C55.1082 25.3181 54.4323 25.5882 54.4323 25.5882L54.692 26.0212C50.4769 29.3422 40.86 36.9391 39.9953 37.804C38.8848 38.9145 46.6585 67.2474 46.6585 51.1304C46.6585 37.6653 54.1393 34.9986 61.0953 33.362C64.2417 32.6216 65.1672 30.7708 65.5373 28.9199C65.9076 27.0691 62.2059 23.3672 61.0953 23.3672Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.426 30.0306C66.462 37.3415 70.5339 40.65 74.3514 41.6217C76.4432 42.1542 75.5314 35.5833 75.5314 35.5833C75.5314 35.5833 72.5699 27.9947 72.1998 27.8097C71.8297 27.6246 68.8682 21.1465 68.8682 21.1465L62.2051 26.6992L64.426 30.0306Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6373 63.8014C48.5176 65.4912 46.2347 66.6792 41.5497 66.6792H41.1512C33.8881 66.6792 28 72.1483 28 78.895V106.669C28 108.509 29.6058 110 31.5867 110H66.1196L49.6373 63.8014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1102 63.8014C69.2299 65.4912 71.5128 66.6792 76.1978 66.6792H76.5962C83.8594 66.6792 89.7475 72.1483 89.7475 78.895V106.669C89.7475 108.509 88.1417 110 86.1608 110H51.6279L68.1102 63.8014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.374 26L45.374 17.3846C47.374 15.9487 50.374 12 59.374 12C68.374 12 71.7074 15.9487 73.374 17.3846L69.374 26C68.2074 25.2821 63.774 23.8462 59.374 23.8462C54.974 23.8462 50.874 25.2821 49.374 26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3904 17.0164H60.3576V15.9836C60.3576 15.4401 59.9175 15 59.374 15C58.8305 15 58.3904 15.4401 58.3904 15.9836V17.0164H57.3576C56.8146 17.0164 56.374 17.4565 56.374 18C56.374 18.543 56.8146 18.9836 57.3576 18.9836H58.3904V20.0159C58.3904 20.5594 58.8305 21 59.374 21C59.9175 21 60.3576 20.5594 60.3576 20.0159V18.9831H61.3904C61.9334 18.9831 62.374 18.543 62.374 17.9995C62.374 17.4565 61.9334 17.0164 61.3904 17.0164Z",
    fill: "#89B59F"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.27543C0 5.93148 0.291786 5.64485 0.664196 5.6341C0.779375 5.63051 11.8634 5.25789 18.3595 0.163032C18.6282 -0.0519407 19.0237 -0.0555235 19.2924 0.15945L19.2963 0.163032C25.7923 5.26148 36.8495 5.6341 36.9608 5.63768C37.3294 5.64843 37.625 5.93148 37.625 6.27902V6.32918C37.625 15.1861 36.0739 27.5685 28.4261 36.2427C23.7959 41.4952 19.2079 42.8782 19.0121 42.9355L18.8048 43L18.5898 42.9355C18.394 42.8782 13.8329 41.4952 9.20277 36.2427C1.55107 27.5649 0 15.1861 0 6.32559V6.27543Z",
    fill: "#3A8761"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5735 21.0833L16.7399 25.0842C17.1272 25.4561 17.739 25.4557 18.1259 25.0834L27.1772 16.373C27.8312 15.7436 27.8312 14.6969 27.1772 14.0675C26.5578 13.4714 25.578 13.4714 24.9586 14.0675L17.43 21.3126L14.7896 18.776C14.1695 18.1803 13.1894 18.1814 12.5706 18.7786C11.9178 19.4086 11.9191 20.4549 12.5735 21.0833Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_40_2721",
    x: -59,
    y: -44,
    width: 230,
    height: 239.231,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.239216 0 0 0 0 0.270588 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_40_2721"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_40_2721",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgCareInsurance);
export default __webpack_public_path__ + "static/media/imgCareInsurance.fc0ad62d789f92004a643ba2d14435dc.svg";
export { ForwardRef as ReactComponent };